import React, { useState, useEffect } from "react";
import { Button, Col, Row, Container, Card, Spinner } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";

import { getSignedUrl, submitComment } from "ServerAPI/serverAPI";
import Form from "react-bootstrap/Form";

const CommentHandler = ({ commentData }) => {
  const [commentInput, setCommentInput] = useState("");
  const [comments, setComments] = useState([]);
  const { courseId } = useParams();
  const [cookies] = useCookies();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setComments(commentData);
  }, [commentData]);

  const commentHandler = async () => {
    const newComment = {
      email: cookies.email,
      comment: commentInput,
      courseId: courseId,
    };

    setComments((prevComments) => [...prevComments, newComment]);

    try {
      const res = await submitComment(newComment);
      if (res) {
        setCommentInput("");
      }
    } catch (e) {
      console.error("Error submitting comment:", e);
    }
  };

  const EmailDisplay = ({ comment }) => {
    const firstTwoLetters = comment?.email?.slice(0, 2).toUpperCase();

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            backgroundColor: "#23479f",
            color: "white",
            display: "inline-block",
            textAlign: "center",
            lineHeight: "30px",
            fontSize: "15px",
            fontWeight: "bold",
            marginRight: "10px",
          }}
        >
          {firstTwoLetters}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <span style={{ fontWeight: "bold" }}>{comment.email}</span>
        </div>
      </div>
    );
  };

  return (
    <section className="mt-0 course-container">
      <Container fluid>
        <Row>
          <Col sm={12} md={12} lg={12}>
            <div className="content">
              <Card className="w-full p-4 my-4">
                <div
                  className="d-flex justify-content-between"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <h4 className="text-2xl font-bold mb-0">Discussion Forum</h4>
                  <div className="text-dark">
                    {isOpen ? (
                      <i className="bi bi-chevron-up"></i>
                    ) : (
                      <i className="bi bi-chevron-down"></i>
                    )}
                  </div>
                </div>
                {isOpen && (
                  <>
                    <div style={{ overflowY: "auto", height: "300px" }}>
                      <Form className="d-flex flex-column align-items-start w-full rounded-[10px]">
                        <textarea
                          rows={5}
                          placeholder="Post Your Comments..."
                          value={commentInput}
                          onChange={(e) => setCommentInput(e.target.value)}
                          className="w-full resize-none my-4"
                          style={{
                            width: "100%",
                            borderRadius: "8px",
                            padding: "10px",
                            borderColor: "#c2c5c6",
                          }}
                          required
                        />
                        <Button
                          onClick={commentHandler}
                          variant="primary"
                          className="ml-4 align-self-end"
                        >
                          Post
                        </Button>
                      </Form>
                      <div>
                        <h4 className="text-2xl font-bold my-2 flex items-center">
                          Comments:
                          {/* <span
                            style={{
                              marginLeft: "0.2rem",
                              backgroundColor: "#efb19b",
                              color: "red",
                              borderRadius: "10px 10px",
                              padding: "0.2rem 0.7rem",
                            }}
                          >
                            {comments.length}
                          </span> */}
                        </h4>
                        {comments.length > 0 ? (
                          comments.map((comment, index) => (
                            <div key={index} className="my-2">
                              <EmailDisplay comment={comment} />
                              <div>{comment.comment}</div>
                            </div>
                          ))
                        ) : (
                          <div className="text-gray-500 italic">
                            Be the first one to comment.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CommentHandler;
